// import React from "react"
import {
  SHOW_TURNTABLE,
  SET_TURNTABLE_SIZE,
  SET_RESULT_SELECTED,
  SET_CHOICES,
  SET_MODE,
  CHANGE_KEY_TEXT,
  SAVE_LOCAL_CHOICES_LIST,
  SET_HISTORY,
  SET_TITLE_OBJ,
  SET_WEIGHT_ON,
  SET_SAVED_LISTS,
  INSTANT_INIT,
  RESET_INITIAL_STATE,
  REPLACE_STATE,
  SET_HEADLINE_ON,
  SET_COLOR_ON,
  SET_INPUT_SHOW_MODE,
  SET_INPUT_EDIT_MODE,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
  SET_SCORES,
  SET_AUTO_ADD_COUNT,
  SET_CHOICE_HD_IMAGES,
  SET_AI_INPUT_LOGIN,
  SET_AI_INPUT_OPENED,
  SET_AI_INPUT_GROUPS,
} from './constants'
import { createReducer } from '../reducerUtil'
// import Turntable from "../../component/Turntable"
import cuid from 'cuid'

const initialState = {
  resultSelected: null, //main is object
  resultIndex: -1, // must remove the filtered===true first for result index
  resultPieColor: null, // follow pie color to show as pop up result border color
  choices: [],
  title: {
    active: false,
    text: '',
    description: '',
    popup: '',
  },
  history: [],
  weightOn: false,
  turnTable: null,
  turnTableSize: 300,
  inputKeyText: cuid(),
  mode: 0,
  // pastIP: '',
  // listName: '',
  savedChoicesList: {
    // A: { name: '', choices: [] },
    // B: { name: '', choices: [] },
    // C: { name: '', choices: [] },
    // D: { name: '', choices: [] },
    // E: { name: '', choices: [] },
    // F: { name: '', choices: [] },
    // G: { name: '', choices: [] },
    // H: { name: '', choices: [] },
    // I: { name: '', choices: [] },
    // J: { name: '', choices: [] },
    // K: { name: '', choices: [] },
    // L: { name: '', choices: [] },
    // M: { name: '', choices: [] },
    // N: { name: '', choices: [] },
    // O: { name: '', choices: [] },
  },
  headlineOn: false,
  colorOn: false,
  inputShowMode: ['Input'], // ['Weight', 'Label', 'Input', 'Color'],
  inputEditMode: 'Main', //Main, Text
  mysteryWheelOn: false,
  mysteryResultOn: false,
  scores: [],
  autoAddCount: false, // popup result tick checkbox to add count
  choiceHDImages: [], // temporary Blob URLs for choice images (cleared on refresh; uploaded to R2 on Save File)
  // e.g. [{index: 0, imageUrl: "blob:http://...", filename: "photoA.png" }, {index: 2, imageUrl: "blob:http://...", filename: "photoB.jpeg" }]
  showAiInputLogin: false,
  hasOpenedAiInput: false,
  aiInputGroups: [], // in-memory only, not persisted: resets on refresh, kept across open/close within a session
}

export const showTurntable = (state, payload) => {
  return {
    ...state,
    turnTable: payload.turntable,
  }
}

export const setTurntableSize = (state, payload) => {
  return {
    ...state,
    turnTable: state.turnTableSize === payload.size ? state.turnTable : null,
    turnTableSize: payload.size,
    // turnTable: null,
  }
}

export const setResultSelected = (state, payload) => {
  return {
    ...state,
    resultSelected: payload.result,
    resultIndex: payload.resultIndex,
    resultPieColor: payload.resultPieColor,
  }
}
export const setChoices = (state, payload) => {
  return {
    ...state,
    choices: payload.choices,
    // turnTable: payload.nullTurntable ? null : state.turnTable,
    turnTable: null,
  }
}

export const setHistory = (state, payload) => {
  return {
    ...state,
    history: payload.history,
  }
}

export const setMode = (state, payload) => {
  return {
    ...state,
    mode: payload.mode,
  }
}

export const changeKeyText = (state, payload) => {
  return {
    ...state,
    inputKeyText: cuid(),
  }
}

export const saveLocalChoicesList = (state, payload) => {
  return {
    ...state,
    savedChoicesList: {
      ...state.savedChoicesList,
      [payload.data.id]: payload.data,
    },
  }
}

export const setSavedLists = (state, payload) => {
  return {
    ...state,
    savedChoicesList: payload.lists,
  }
}

// export const setTitleActive = (state, payload) => {
//   return {
//     ...state,
//     title: {
//       ...state.title,
//       active: payload.active,
//     },
//   }
// }

// export const setTitleText = (state, payload) => {
//   return {
//     ...state,
//     title: {
//       ...state.title,
//       text: payload.text,
//     },
//   }
// }

export const setTitleObj = (state, payload) => {
  return {
    ...state,
    title: {
      ...state.title,
      ...payload.obj,
    },
  }
}

export const setWeightOn = (state, payload) => {
  return {
    ...state,
    weightOn: payload.status,
    turnTable: null,
  }
}

export const instantInit = (state, payload) => {
  if (!payload.previousState) {
    return {
      ...state,
    }
  } else {
    return {
      ...payload.previousState,
    }
  }
}

export const resetInitialState = (state, payload) => {
  const {
    savedChoicesList,
    turnTableSize,
    inputEditMode,
    ...rest
  } = initialState
  return {
    ...state,
    ...rest,
  }
}

export const replaceState = (state, payload) => {
  return {
    ...state,
    ...payload.data,
    inputKeyText: cuid(),
  }
}

export const setHeadlineOn = (state, payload) => {
  return {
    ...state,
    headlineOn: payload.status,
    turnTable: null,
  }
}

export const setColorOn = (state, payload) => {
  return {
    ...state,
    colorOn: payload.status,
    turnTable: null,
  }
}

export const setInputShowMode = (state, payload) => {
  return {
    ...state,
    inputShowMode: payload.showMode,
  }
}

export const setInputEditMode = (state, payload) => {
  return {
    ...state,
    inputEditMode: payload.mode,
    ...(payload.mode === 'Text' && {
      headlineOn: false,
      colorOn: false,
      turnTable: null,
      inputShowMode: state.inputShowMode.filter(
        item => item !== 'Label' && item !== 'Color',
      ),
      choiceHDImages: state.choiceHDImages.map(item => ({
        ...item,
        status: 'delete',
        index: -1,
      })),
    }),
  }
}

export const setMysteryWheelOn = (state, payload) => {
  return {
    ...state,
    mysteryWheelOn: payload.status,
    turnTable: null,
  }
}

export const setMysteryResultOn = (state, payload) => {
  return {
    ...state,
    mysteryResultOn: payload.status,
  }
}

export const updateMysterySettings = (state, payload) => {
  return {
    ...state,
    mysteryWheelOn: payload.mysteryWheelOn,
    mysteryResultOn: payload.mysteryResultOn,
  }
}

export const setScores = (state, payload) => {
  return {
    ...state,
    scores: payload.scores,
  }
}

export const setAutoAddCount = (state, payload) => {
  return {
    ...state,
    autoAddCount: payload.status,
  }
}

export const setChoiceHDImages = (state, payload) => {
  return {
    ...state,
    choiceHDImages: payload.choiceHDImages.sort((a, b) => a.index - b.index),
  }
}

export const setAiInputLogin = (state, payload) => {
  return {
    ...state,
    showAiInputLogin: payload.show,
  }
}

export const setAiInputOpened = (state, payload) => {
  return {
    ...state,
    hasOpenedAiInput: payload.status,
  }
}

export const setAiInputGroups = (state, payload) => {
  return {
    ...state,
    aiInputGroups: payload.groups,
  }
}

export default createReducer(initialState, {
  [SHOW_TURNTABLE]: showTurntable,
  [SET_RESULT_SELECTED]: setResultSelected,
  [SET_CHOICES]: setChoices,
  [SET_MODE]: setMode,
  [CHANGE_KEY_TEXT]: changeKeyText,
  [SET_TURNTABLE_SIZE]: setTurntableSize,
  [SAVE_LOCAL_CHOICES_LIST]: saveLocalChoicesList,
  [SET_HISTORY]: setHistory,
  [SET_TITLE_OBJ]: setTitleObj,
  [SET_WEIGHT_ON]: setWeightOn,
  [SET_SAVED_LISTS]: setSavedLists,
  [INSTANT_INIT]: instantInit,
  [RESET_INITIAL_STATE]: resetInitialState,
  [REPLACE_STATE]: replaceState,
  [SET_HEADLINE_ON]: setHeadlineOn,
  [SET_COLOR_ON]: setColorOn,
  [SET_INPUT_SHOW_MODE]: setInputShowMode,
  [SET_INPUT_EDIT_MODE]: setInputEditMode,
  [SET_MYSTERY_WHEEL_ON]: setMysteryWheelOn,
  [SET_MYSTERY_RESULT_ON]: setMysteryResultOn,
  [UPDATE_MYSTERY_SETTINGS]: updateMysterySettings,
  [SET_SCORES]: setScores,
  [SET_AUTO_ADD_COUNT]: setAutoAddCount,
  [SET_CHOICE_HD_IMAGES]: setChoiceHDImages,
  [SET_AI_INPUT_LOGIN]: setAiInputLogin,
  [SET_AI_INPUT_OPENED]: setAiInputOpened,
  [SET_AI_INPUT_GROUPS]: setAiInputGroups,
})
